<template>
  <div class="config-page">
    <div class="page-header">
      <h2>系统配置</h2>
    </div>
    <el-form :model="configForm" label-width="180px" class="config-form">
      <el-form-item label="文章详情页地址">
        <el-input v-model="configForm.articleDetailUrl" placeholder="请输入文章详情页地址" style="width: 400px;">
          <template slot="append">/article/{id}</template>
        </el-input>
        <span class="form-tip">注意：{id} 会被替换为文章ID</span>
      </el-form-item>
      <el-form-item label="开启评论审核">
        <el-switch v-model="configForm.requireAudit" active-text="开启" inactive-text="关闭"></el-switch>
        <span class="form-tip">开启后，新评论需要审核通过才能在博客详情页显示</span>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="saveConfigs">保存配置</el-button>
        <el-button @click="loadConfigs">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getConfigs, updateConfigs } from '@/api/blog'

export default {
  name: 'ConfigPage',
  data() {
    return {
      configForm: {
        articleDetailUrl: '',
        requireAudit: false
      }
    }
  },
  mounted() {
    this.loadConfigs()
  },
  methods: {
    async loadConfigs() {
      const res = await getConfigs()
      this.configForm.articleDetailUrl = res.data['article.detail-url'] || 'http://localhost:8082'
      this.configForm.requireAudit = res.data['comment.require-audit'] === 'true'
    },
    async saveConfigs() {
      const configs = {
        'article.detail-url': this.configForm.articleDetailUrl,
        'comment.require-audit': String(this.configForm.requireAudit)
      }
      await updateConfigs(configs)
      this.$message.success('配置保存成功')
    }
  }
}
</script>

<style scoped>
.config-page {
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.config-form {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
}

.form-tip {
  margin-left: 10px;
  color: #999;
  font-size: 12px;
}
</style>